/* eslint-disable @typescript-eslint/no-empty-function */

import { createContext } from 'react'
import { BeneficiaryType } from 'types/beneficiary'

  interface BeneficiaryContextProps {
    beneficiaries: BeneficiaryType | null
    setBeneficiaries: (beneficiaries: BeneficiaryType | null) => void
  }
  
  const BeneficiaryContext = createContext<BeneficiaryContextProps>({
    beneficiaries: null,
    setBeneficiaries: () => {},
  })
  
  export default BeneficiaryContext